import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { ActivitiesEmptyGhostRow } from "web_myplann/Activities/Components/ActivitiesEmptyGhostRow";
import { ACTIVITY_EMPTY_GHOST_ROWS } from "web_myplann/Activities/constants";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const ActivitiesEmptyState: FC = () => {
	const { spacingTokens } = useTheme();
	const { t } = useResource();

	return (
		<Stack
			px={spacingTokens.xl}
			pt={spacingTokens.xxl}
			gap={spacingTokens.xl}
			data-testid="activities-list-page"
		>
			<Stack gap={spacingTokens.sm}>
				{ACTIVITY_EMPTY_GHOST_ROWS.map((row) => (
					<ActivitiesEmptyGhostRow key={row} />
				))}
			</Stack>
			<Stack alignItems="center" textAlign="center" gap={spacingTokens.xs}>
				<Typography variant="bodyStrong">
					{t(Resources.Activity.List.NoContent)}
				</Typography>
				<Typography variant="body2">
					{t(Resources.Activity.List.NoActivities)}
				</Typography>
			</Stack>
		</Stack>
	);
};
